import { AxiosRequestConfig } from 'axios';
import { IMedia } from '../../lib/MediasLib';
import addUploadCapabilities from '../../lib/addUploadCapabilities';
import { restApi } from '../../services/api';
import { AutoSaveMediaApi } from '../media/useMediaListManager';

export const brandShowcaseRepository = (brandId: string | undefined): AutoSaveMediaApi => {
  const repository = {
    create: (data: IMedia, axiosConfig?: AxiosRequestConfig) =>
      restApi.post(`showroom/media-showcase`, data, axiosConfig),
    update: (data: IMedia, axiosConfig?: AxiosRequestConfig) =>
      restApi.patch(`showroom/media-showcase/${data.id}`, data, axiosConfig),
    remove: (data: IMedia) => restApi.delete(`showroom/media-showcase/${data.id}`),
    list: () => restApi.get(`showroom/${brandId}/media-showcase?limit=1000`),
  };

  addUploadCapabilities(repository);
  return repository;
};
